import axiosClient from './axiosClient';

const settingsApi = {
  getSettingByType: (type) => {
    const url = `/settings/${type}`;
    return axiosClient.get(url);
  },
  getAdminDashboardCount: (param) => {
    const url = `report/get-total-count?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },
};

export default settingsApi;
